import { RecommendationFeature } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { useDisplayPrices } from './useDisplayPrices';
import { useMatchingLabels } from './useMatchingLabels';
import { useResultsPageOfferingsBi } from './useResultsPageOfferingsBi';
export const PRE_SUGGESTIONS_FALLBACK_QUERY = 'mystunningwebsite';
export const usePreSuggestions = function (fallbackQuery) {
  if (fallbackQuery === void 0) {
    fallbackQuery = PRE_SUGGESTIONS_FALLBACK_QUERY;
  }
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useListRecommendations({
      query: fallbackQuery,
      features: [RecommendationFeature.USE_BUSINESS_INFO],
      paging: {
        limit: 3
      }
    }, true, {
      cacheTime: Infinity,
      staleTime: Infinity,
      useErrorBoundary: false
    }),
    data = _DomainsApiClient$hoo.data,
    isLoading = _DomainsApiClient$hoo.isLoading,
    error = _DomainsApiClient$hoo.error;
  const baseRecommendations = (data == null ? void 0 : data.recommendations) ?? [];
  const _useDisplayPrices = useDisplayPrices([baseRecommendations]),
    pricesByDomain = _useDisplayPrices.pricesByDomain,
    isPricingLoading = _useDisplayPrices.isLoading;
  const recommendations = baseRecommendations.map(recommendation => recommendation.domain && pricesByDomain.has(recommendation.domain) ? {
    ...recommendation,
    price: pricesByDomain.get(recommendation.domain)
  } : recommendation);
  useResultsPageOfferingsBi({
    recommendations: baseRecommendations,
    isLoading
  });
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.SDK.useSuggestionActionResolver(),
    resolveActionForSuggestion = _DomainSearchSuiteMod.resolveActionForSuggestion;
  const _DomainsApiClient$hoo2 = DomainsApiClient.hooks.useGetPurchasePermissions({}),
    purchasePermissions = _DomainsApiClient$hoo2.data;
  const _useMatchingLabels = useMatchingLabels(recommendations),
    matchLabels = _useMatchingLabels.labels,
    isLoadingLabels = _useMatchingLabels.isLoading;
  const onGetItClick = async recommendation => {
    const position = recommendations.findIndex(_ref => {
      let id = _ref.id;
      return id === recommendation.id;
    });
    DomainSearchSuiteModule.internals.bi.onGetItClick == null || DomainSearchSuiteModule.internals.bi.onGetItClick({
      domain: recommendation.domain || '',
      type: recommendation.label,
      position
    });
    if (recommendation.domain) {
      await resolveActionForSuggestion(recommendation.domain);
    }
  };
  return {
    recommendations,
    isLoading,
    isPricingLoading,
    matchLabels,
    isLoadingLabels,
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    hidden: Boolean(error) || !isLoading && !baseRecommendations.length,
    onGetItClick
  };
};
//# sourceMappingURL=usePreSuggestions.js.map